import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import About from "./About";
import Clients from "./Clients";
import Education from "./Education";
import Faqs from "./Faqs";
import Hero from "./Hero";
import Services from "./Services";
import Teams from "./Teams";

function Home() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Faqs />
      <Education />
      <Clients />
      <Teams />
      <Footer />
    </>
  );
}
export default Home;
